import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import logo from '../../styles/images/elextra_varv.svg';
import './logo.css';

class Logo extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  render() {
    const { t } = this.props;

    return (
      <div className="company-logo">
        <img
          src={logo}
          alt={t('company_title')}
          className="company-logo__image"
        />
      </div>
    );
  }
}

export default Logo;
